import { IonPage, IonContent} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";


class RefundTutelage extends Component {

    render() {

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont">
                        <div className="guide-head">
                            <a href="/phone/refundTutelage" className="on">监护引导</a>
                            <a href="/phone/refundFlow">申请流程</a>
                            <a href="/h5accountRefund">点我申请</a>
                        </div>
                        <div className="guide_cont">
                            <p>网络游戏未成年人健康成长守护旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系。</p>
                            <h1 className="guide_cont_title">《未成年人健康参与网络游戏提示》</h1>
                            <p>随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：</p>
                            <p>一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。<br/><br/>
                                二、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。<br/><br/>
                                三、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。<br/><br/>
                                四、注意保护个人信息。包括个人、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络诈骗和网络犯罪。
                            </p>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(RefundTutelage);
